export type UtilsTranslation = {
  dictionaries: {
    yesNo: {
      no: string;
      yes: string;
    };
  };
};

export const utilsTranslation: UtilsTranslation = {
  dictionaries: {
    yesNo: {
      no: 'No',
      yes: 'Yes',
    },
  },
};
